<script setup>
import { storeToRefs } from 'pinia';

import { RotateCcw } from 'lucide-vue-next';

import { useEnvironmentStore } from '@/stores/environment';

// Persistent escape hatch for the dev environment-simulation override. Renders only
// while a simulation is active, so it's invisible in normal use. Always reachable
// (header), guaranteeing you can restore the real environment from any page even after
// the dev navigation has been hidden by the simulation itself.
const envStore = useEnvironmentStore();
const { isEnvOverrideActive, effectiveEnvironment } = storeToRefs(envStore);
</script>

<template>
  <button
    v-if="isEnvOverrideActive"
    type="button"
    class="env-override-chip"
    :title="`Simulating the ${effectiveEnvironment} environment — click to restore the real one`"
    @click="envStore.resetEnvironment()"
  >
    <span class="env-override-chip-label">Simulating {{ effectiveEnvironment }}</span>
    <RotateCcw :size="13" class="env-override-chip-icon" />
  </button>
</template>

<style scoped>
.env-override-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  text-transform: capitalize;
  color: var(--wp-text-danger);
  background: var(--wp-surface-card);
  border: 1px solid var(--wp-text-danger);
  border-radius: 14px;
  cursor: pointer;
  white-space: nowrap;
}

.env-override-chip:hover {
  background: var(--wp-surface-muted);
}

.env-override-chip-icon {
  flex-shrink: 0;
}
</style>
